import { useQuery } from 'urql';
import { graphql } from '@/gql/graphql';
import type { JoinKind } from '@/stores/useJoinIntentStore';

const PreviewMembershipInvite = graphql(`
  query PreviewMembershipInvite($kind: invite_entry_kind!, $code: String!) {
    invite_entry_preview(args: { kind: $kind, code: $code }) {
      entity_id
      title
      status
    }
  }
`);

type Preview = {
  entityId: string;
  title: string;
  status: 'available' | 'locked';
};

export default function useInvitePreview(kind: JoinKind, code: string) {
  const [result, retry] = useQuery({
    query: PreviewMembershipInvite,
    variables: { kind, code },
    pause: code.length !== 8,
    requestPolicy: 'network-only',
  });
  let preview: Preview | null = null;
  const entry = result.data?.invite_entry_preview[0];
  if (
    entry?.entity_id &&
    entry.title &&
    (entry.status === 'available' || entry.status === 'locked')
  ) {
    preview = {
      entityId: entry.entity_id,
      title: entry.title,
      status: entry.status,
    };
  }
  return {
    preview: result.fetching ? null : preview,
    fetching: result.fetching,
    error: result.error,
    received: result.data !== undefined,
    retry,
  };
}
